export default class OPLLocations {
    constructor() {
        this.mapElement = document.getElementById('location-map');
        this.currentLocationBtns = document.querySelectorAll('.opl-locations-main-search-current');
        this.locationsSearchForms = document.querySelectorAll('.opl-locations-main-search-field');
        this.locationsSearchMessages = document.querySelectorAll('.opl-locations-main-search-message');
        this.branchList = document.querySelector('.opl-locations-main-list-branches');

        this.startLocation = { lat: 43.4643954, lng: -79.7045677 };
        this.mapMediaQuery = window.matchMedia('(min-width: 1024px)');
        this.svgMarkerPath = 'M10.5781 29.9741C10.8125 30.3843 11.2227 30.5601 11.75 30.5601C12.2188 30.5601 12.6289 30.3843 12.9219 29.9741L16.8477 24.3491C18.7812 21.5366 20.0703 19.6616 20.7148 18.6655C21.5938 17.2593 22.1797 16.0874 22.5312 15.1499C22.8242 14.2124 23 13.0991 23 11.8101C23 9.81787 22.4727 7.94287 21.4766 6.18506C20.4219 4.48584 19.0742 3.13818 17.375 2.0835C15.6172 1.0874 13.7422 0.560059 11.75 0.560059C9.69922 0.560059 7.82422 1.0874 6.125 2.0835C4.36719 3.13818 3.01953 4.48584 2.02344 6.18506C0.96875 7.94287 0.5 9.81787 0.5 11.8101C0.5 13.0991 0.617188 14.2124 0.96875 15.1499C1.26172 16.0874 1.84766 17.2593 2.78516 18.6655C3.37109 19.6616 4.66016 21.5366 6.65234 24.3491C8.23438 26.6343 9.52344 28.5093 10.5781 29.9741Z';

        this.DEFAULT_ZOOM = 11;
        this.SELECTED_ZINDEX = 1;

        this.branches = window.OPL?.branches ?? null;
        this.googleMapID = window.OPL?.GoogleMapID ?? null;

        this.map = null;
        this.geocoder = null;
        this.branchesData = {};
        this.infowindow = null;
        this.userMarker = null;
    }

    init() {
        if (this.mapElement) {
            window.mapsReady.then(() => {
                this.initLocations();
            });
        }
    }

    initLocations() {
        this.map = new google.maps.Map(this.mapElement, {
            center: new google.maps.LatLng(this.startLocation),
            zoom: this.mapMediaQuery.matches ? 12 : this.DEFAULT_ZOOM,
            disableDefaultUI: true,
            mapId: this.googleMapID
        });

        this.geocoder = new google.maps.Geocoder();
        this.infowindow = new google.maps.InfoWindow({ content: this.content });

        if (this.branches) {
            this.branches.forEach(branch => {
                const svgIcon = this.createSvgIcon(branch.LocationCategoryColour);
                const marker = new google.maps.marker.AdvancedMarkerElement({
                    map: this.map,
                    position: { lat: branch.LocationLat, lng: branch.LocationLng },
                    content: svgIcon,
                    title: branch.Name
                });

                const listElement = document.querySelector(`.opl-locations-main-list-branches-item[data-branch-id="${branch.BranchID}"]`);
                if (!listElement) return;

                this.branchesData[branch.BranchID] = {
                    icon: svgIcon,
                    googleMarkerObject: marker,
                    branchData: branch,
                    listElement: listElement
                };

                marker.addListener('gmp-click', () => this.selectBranchElement(branch.BranchID, true));
                listElement.addEventListener('click', () => this.selectBranchElement(branch.BranchID));
            });

            this.currentLocationBtns.forEach(btn => btn.addEventListener('click', this.getCurrentLocation.bind(this)));
            this.locationsSearchForms.forEach(form => form.addEventListener('submit', this.searchByInput.bind(this)));
        }
    }

    createSvgIcon(fill, stroke = null) {
        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.setAttribute("width", "24");
        svg.setAttribute("height", "30");
        svg.setAttribute("viewBox", "0 0 24 30");
        svg.setAttribute("fill", "none");
        svg.style.overflow = "visible";

        const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
        path.setAttribute("d", this.svgMarkerPath);
        path.setAttribute("fill", fill || "#440099");
        if (stroke) {
            path.setAttribute("stroke", stroke);
            path.setAttribute("stroke-width", "1.5");
        }

        svg.appendChild(path);
        return svg;
    }

    selectBranchElement(targetBranchID, pushToTop = false) {
        if (this.userMarker) this.userMarker.setMap(null);

        const previousClone = this.branchList.querySelector('.first-selected');
        if (previousClone) previousClone.remove();

        const previousHidden = this.branchList.querySelector('.hide');
        if (previousHidden) previousHidden.classList.remove('hide');

        for (const branchID in this.branchesData) {
            const branch = this.branchesData[branchID];
            const isTarget = parseInt(branchID, 10) === targetBranchID;

            const button = branch.listElement.querySelector('.opl-locations-main-list-branches-item-accordion-button');
            const body = branch.listElement.querySelector('.opl-locations-main-list-branches-item-accordion-body');

            branch.listElement.classList.toggle('active', isTarget);
            if (button && body) {
                button.setAttribute('aria-expanded', isTarget.toString());
                button.classList.toggle('js-is-active', isTarget);
                body.classList.toggle('js-is-visible', isTarget);
            }

            branch.googleMarkerObject.content = isTarget
                ? this.createSvgIcon(branch.branchData.LocationCategoryColour, "#000")
                : branch.icon;

            branch.googleMarkerObject.zIndex = isTarget ? this.SELECTED_ZINDEX : 0;
        }

        const targetBranch = this.branchesData[targetBranchID];
        if (this.mapMediaQuery.matches) {
            this.branchList.scrollTo(0, targetBranch.listElement.offsetTop);
        } else if (pushToTop) {
            const clone = targetBranch.listElement.cloneNode(true);
            targetBranch.listElement.classList.add('hide');
            clone.classList.add('first-selected');
            clone.style.order = '-1';
            this.branchList.appendChild(clone);
        }

        if (this.map.getZoom() < 20 || !this.map.getBounds().contains(targetBranch.googleMarkerObject.position)) {
            this.zoomIntoLocation(1000, {
                lat: targetBranch.branchData.LocationLat,
                lng: targetBranch.branchData.LocationLng
            });
        }
    }

    zoomIntoLocation(radius, { lat, lng }) {
        const position = new google.maps.LatLng({ lat, lng });
        const circle = new google.maps.Circle({
            center: position,
            fillOpacity: 0,
            strokeOpacity: 0,
            map: this.map,
            radius: radius
        });
        this.map.fitBounds(circle.getBounds(), 0);
        circle.setMap(null);
    }

    setUserLocation({ lat, lng }) {
        const position = new google.maps.LatLng({ lat, lng });
        const distances = [];
        let resultRadius = 5000;
        let anyMarkersWithinRadius = false;

        for (const branchID in this.branchesData) {
            const branch = this.branchesData[branchID];
            const distance = google.maps.geometry.spherical.computeDistanceBetween(position, branch.googleMarkerObject.position);

            distances.push({ branchID, distance });
            if (distance < 5000) anyMarkersWithinRadius = true;

            this.updateAccordionUI(branch, false);
            branch.googleMarkerObject.content = branch.icon;
        }

        distances.sort((a, b) => a.distance - b.distance);
        if (!anyMarkersWithinRadius && distances.length > 0) {
            resultRadius = distances[0].distance;
        }

        distances.forEach((distance, index) => {
            this.branchesData[distance.branchID].listElement.style.order = index + 1;
        });
        
        this.userMarker = new google.maps.marker.AdvancedMarkerElement({
            map: this.map,
            position: position,
        });
        
        this.zoomIntoLocation(resultRadius, { lat, lng });
    }
    
    searchByInput(e) {
        e.preventDefault();
        this.setSearchMessage(false);

        const formData = new FormData(e.target);
        const locationInput = formData.get("location");

        if (locationInput) {
            const query = locationInput.trim().split(" ").join("+");
            if (this.userMarker) this.userMarker.setMap(null);

            this.geocoder.geocode({ address: query }, (results, status) => {
                if (status === 'OK') {
                    const { lat, lng } = results[0].geometry.location;
                    this.setUserLocation({ lat: lat(), lng: lng() });
                    this.branchList.scroll(0, 0);
                } else {
                    this.setSearchMessage(true, "Please enter a valid address or postal code.");
                }
            });
        }
    }

    getCurrentLocation(e) {
        e.preventDefault();
        this.setSearchMessage(false);
        if (this.userMarker) this.userMarker.setMap(null);

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(({ coords }) => {
                this.setUserLocation({ lat: coords.latitude, lng: coords.longitude });
                this.branchList.scroll(0, 0);
            });
        } else {
            this.setSearchMessage(true, "Geolocation is not available. Please enable geolocation for this website.");
        }
    }

    setSearchMessage(isShown, msg = "") {
        this.locationsSearchMessages.forEach(div => {
            div.innerHTML = msg;
            div.classList.toggle('hide', !isShown);
            this.branchList.classList.toggle('message-shown', isShown);
        });
    }

    updateAccordionUI(branch, expand) {
        const button = branch.listElement.querySelector('.opl-locations-main-list-branches-item-accordion-button');
        const body = branch.listElement.querySelector('.opl-locations-main-list-branches-item-accordion-body');

        branch.listElement.classList.toggle('active', expand);
        if (button && body) {
            button.setAttribute('aria-expanded', expand.toString());
            button.classList.toggle('js-is-active', expand);
            body.classList.toggle('js-is-visible', expand);
        }
    }

}
